import { createContext, useContext, useEffect, useState } from "react";
import { translations } from "./translations";

const LangContext = createContext(null);

export const LangProvider = ({ children }) => {
    const [lang, setLang] = useState(() => (localStorage.getItem("hm-lang") === "sw" ? "sw" : "en"));

    useEffect(() => {
        localStorage.setItem("hm-lang", lang);
        document.documentElement.lang = lang === "sw" ? "sw" : "en";
    }, [lang]);

    return <LangContext.Provider value={{ lang, setLang, t: translations[lang] }}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);
